import FeedConfiguration from './FeedConfiguration'

export const loadSavedFeeds = () => {
  const savedFeeds = JSON.parse(localStorage.getItem('RespondSavedFeeds') ?? '[]') ?? []
  if (Array.isArray(savedFeeds)) {
    return savedFeeds
      .map(savedFeed => FeedConfiguration.configurationFromSaved(savedFeed))
      .filter(config => config !== null) as FeedConfiguration[]
  }
  return []
}

export const updateSavedFeeds = (feeds: FeedConfiguration[]) => {
  const value = JSON.stringify(feeds.map(feed => feed.toSaved()))
  localStorage.setItem('RespondSavedFeeds', value)
}
